<div class="topdata-pb-product-settings">

    <sw-loader
            v-show="isLoading"
            size="48px"
    ></sw-loader>

    <div v-if="topdataPbProductExtension">

        <p class="topdata-pb-property-groups__hint" style="margin: 0 0 8px 0;">
            {{ $tc('TopdataProductBoxesSW6.productDetailSettings.hint') }}
        </p>

        <sw-loader v-if="isLoadingGroups" size="30px"></sw-loader>

        <div v-else-if="propertyGroupSelectOptions.length === 0" class="topdata-pb-property-groups__empty">
            {{ $tc('TopdataProductBoxesSW6.productDetailSettings.empty') }}
        </div>

        <template v-else>

            <sw-multi-select
                    :value="selectedPropertyGroupIds"
                    :options="propertyGroupSelectOptions"
                    :label="$tc('TopdataProductBoxesSW6.productDetailSettings.listingLabel')"
                    :placeholder="$tc('TopdataProductBoxesSW6.productDetailSettings.placeholder')"
                    :disabled="isLoading"
                    @update:value="onPropertyGroupChange"
            ></sw-multi-select>

            <sw-multi-select
                    :value="selectedDetailPropertyGroupIds"
                    :options="propertyGroupSelectOptions"
                    :label="$tc('TopdataProductBoxesSW6.productDetailSettings.detailLabel')"
                    :placeholder="$tc('TopdataProductBoxesSW6.productDetailSettings.placeholder')"
                    :disabled="isLoading"
                    style="margin-top: 16px;"
                    @update:value="onDetailPropertyGroupChange"
            ></sw-multi-select>

        </template>

    </div>

</div>
